import { render, staticRenderFns } from "./BcTooltip.vue?vue&type=template&id=3fd74a06"
import script from "./BcTooltip.vue?vue&type=script&lang=js"
export * from "./BcTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports